// Define the route configuration for step-wise registration
const stepRoutes = [
  {
    path: '/course-selection',
    title: 'Course Selection',
    component: 'CourseSelection',
    previousPath: '/',
    nextPath: 'state-selection',
  },
  {
    path: '/state-selection',
    title: 'State Selection',
    component: 'StateSelection',
    previousPath: 'course-selection',
    nextPath: 'endorsement-selection',
  },
  {
    path: '/endorsement-selection',
    title: 'Endorsement Selection',
    component: 'EndorsementSelection',
    previousPath: 'state-selection',
    nextPath: 'cdl-type',
  },
  {
    path: '/cdl-type',
    title: 'CDL Type',
    component: 'CDLTypeSelection',
    previousPath: 'endorsement-selection',
    nextPath: 'video-selection',
  },
  {
    path: '/video-selection',
    title: 'Video Selection',
    component: 'VideoSelection',
    previousPath: 'cdl-type',
    nextPath: 'course-recommendation',
  },
  {
    path: '/course-recommendation',
    title: 'Course Recommendation',
    component: 'CourseRecommendation',
    previousPath: 'video-selection',
    nextPath: 'more-class-selection',
  },
  {
    path: '/more-class-selection',
    title: 'More Class Selection',
    component: 'MoreClassSelection',
    previousPath: 'course-recommendation',
    nextPath: '/shoppingcart',
  },
];

export default stepRoutes;
